<!-- 投资事件首页 -->
<template>
  <div class="investmentEvent">
    <div class="container">
      <el-card :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <!-- <el-form-item label="所在城市：">
          <CascaderArea
            :country="queryInfo.nation"
            :province="queryInfo.province"
            :city="queryInfo.city"
            @searchArae="searchArae"
            class="CascaderArea"
          />
        </el-form-item> -->
          <el-form-item label="更新时间">
            <radio-select
              :code.sync="queryInfo.updateTime"
              type-code="018"
              query-name="updateTime"
              name="目前状态"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="轮次：">
            <radio-select
              :code.sync="queryInfo.rank"
              type-code="002"
              query-name="rank"
              name="融资轮次"
              @onChange="onChange"
            />
          </el-form-item>
          <!-- <el-form-item label="筛选结果：">
          <el-tag v-for="(i1,i2) in selectedList" :key="i2" closable @close="deleteTag">{{ i1 }}</el-tag>
        </el-form-item> -->
        </el-form>
      </el-card>
      <el-card class="table_card">
        <div class="clue_list_input_add">
          <div class="input_new">
            <el-input
              placeholder="请输入标题"
              v-model="queryInfo.title"
              clearable
              class="input-with-select"
            >
              <el-button slot="append" @click="searchTalent" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <el-button
            type="primary"
            v-has-permission="'clue/getInvestmentEvent'"
            class="add_clue"
            @click="addSelectedClue"
            >+添加为线索</el-button
          >
        </div>
        <el-table
          ref="clueTableRef"
          class="clue_table"
          :data="tableData"
          @selection-change="SelectionChange"
          @sort-change="sortChange"
        >
          <el-table-column type="selection" width="60"> </el-table-column>
          <el-table-column width="60" label="序号" type="index"> </el-table-column>
          <el-table-column label="标题" prop="title"> </el-table-column>
          <el-table-column label="来源" prop="source" align="center"></el-table-column>
          <el-table-column
            label="关联企业名称"
            prop="enterpriseName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="关联投资机构"
            prop="enterpriseScale"
            align="center"
          ></el-table-column>
          <el-table-column label="轮次" prop="rank" align="center"></el-table-column>
          <el-table-column
            label="投资金额(万)"
            prop="investmentAmount"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            label="最近更新时间"
            prop="createTime"
            width="180"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            class="operation"
            width="140"
            label="操作"
            align="center"
            prop="isCreate"
          >
            <template v-slot="{ row }">
              <div class="operation_bottom">
                <div v-if="addHasPermission" class="click_span">
                  <span v-if="row.isCreate">已添加为线索</span>
                  <span v-else @click="addClue(row)">添加为线索</span>
                </div>
                <div v-if="editHasPermission" class="click_span">
                  <span @click="editInformation(row)">编辑</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.baseParam.pageNum"
        :page-sizes="[10, 50, 100]"
        :page-size="queryInfo.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { pagination } from '@/mixins/pagination'
// import CascaderArea from '@/components/CascaderArea.vue'
import { getInvestmentEvent, saveClue } from '@/api/businessCenter.js'
import radioSelect from '@/components/RadioSelect.vue'
const defaultQueryObj = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  //city: '', //所在城市
  id: 0, //
  //nation: '', //所在国家
  order: '', //排序：默认desc；（正序：desc；反序：asc）
  orderType: 0, //排序类型（默认1）0->投资金额;1->更新时间
  //province: '', //所在省份
  rank: '', //轮次
  source: '', //来源
  updateTime: '', //更新时间：3，7，1
  title: '' //标题
})
const addFormObj = Object.freeze({
  accomplishProject: '', //已完成项目id
  city: '', //城市
  clueCode: '', //线索编号
  clueMessenger: '测试01', //线索信息员
  companyProfiles: '', //企业介绍
  createName: null, //创建人名字
  createTime: '', //创建时间
  customerManager: '', //客户经理
  englishName: null, //商务经理
  enterpriseAbbreviation: '测试01', //企业简称
  enterpriseName: '测试01', //企业全称
  enterpriseSites: '', //企业官网
  establishTime: '', //成立时间
  logo: '', //企业logo
  nation: '中国', //国家
  prepare: '1', //会前准备(1：会前准备；2：已通知；3：已有链接)
  prepareUrl: null, //准备地址
  priority: '3', //优先级别（0->低;1->中;2->高;3->更高;）
  province: '北京', //省份
  schedule: '0', //进度0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
  sourceWay: '1', //来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
  statisticsTime: null, //线索各种数据新增时间
  updateName: null, //修改人名字
  updateTime: null, //修改时间
  investmentEventId: 0 //选中的id
})
export default {
  //CascaderArea
  components: { radioSelect },
  name: 'enterpriseList',
  mixins: [pagination],
  data() {
    return {
      queryInfo: { ...defaultQueryObj },
      //selectedList: [], //筛选结果
      tableData: [], //表格数据
      //table表格中添加按钮提交的数据
      addForm: [{ ...addFormObj }], //接口要求传数组
      selectedList: [], //表格选中的值
      addList: [] //批量添加传的参数
    }
  },
  created() {
    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }
    this.search()
  },
  computed: {
    addHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('clue/saveClueList')
      return hasPermission
    },
    editHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/getInvestmentEvent')
      return hasPermission
    }
  },
  methods: {
    //  轮次改变
    onChange() {
      this.search()
    },
    //  排序
    sortChange(column) {
      let prop = column.prop
      let order = column.order
      if (prop == 'investmentAmount') {
        this.queryInfo.orderType = '0'
      } else if (prop == 'createTime') {
        this.queryInfo.orderType = '1'
      }
      if (order == 'ascending') {
        this.queryInfo.order = 'asc'
      } else if (order == 'descending') {
        this.queryInfo.order = 'desc'
      } else if (order == null) {
        this.queryInfo.order = 'desc'
        this.queryInfo.orderType = null
      }
      this.search()
    },
    // 地址
    /* searchArae(val) {
      this.queryInfo.nation = val.country
      this.queryInfo.province = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.city = val.city
      }
      this.search()
    }, */
    //搜索按钮
    searchTalent() {
      this.search()
      this.queryInfo.baseParam = {
        pageNum: 1,
        pageSize: 10
      }
    },
    //分页查询
    async search() {
      const { data: res } = await getInvestmentEvent(this.queryInfo)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    //监听勾选值变化
    SelectionChange(row) {
      this.selectedList = row
    },
    //添加选中的项为线索
    async addSelectedClue() {
      let Arr = [] //临时变量接收遍历结果
      this.selectedList.map((item) => {
        if (!item.isCreate) {
          Arr.push({
            clueMessenger: item.updateName,
            enterpriseAbbreviation: item.enterpriseName,
            enterpriseName: item.enterpriseName,
            investmentEventId: item.id,
            accomplishProject: '', //已完成项目id
            city: '', //城市
            clueCode: '', //线索编号
            companyProfiles: '', //企业介绍
            createName: null, //创建人名字
            createTime: '', //创建时间
            customerManager: '', //客户经理
            englishName: null, //商务经理
            enterpriseSites: '', //企业官网
            establishTime: '', //成立时间
            logo: '', //企业logo
            nation: '中国', //国家
            prepare: '1', //会前准备(1：会前准备；2：已通知；3：已有链接)
            prepareUrl: null, //准备地址
            priority: '3', //优先级别（0->低;1->中;2->高;3->更高;）
            province: '北京', //省份
            schedule: '0', //进度0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
            sourceWay: '1', //来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
            statisticsTime: null, //线索各种数据新增时间
            updateName: null, //修改人名字
            updateTime: null //修改时间
          })
        }
      })
      this.addList = Arr
      const { data: res } = await saveClue(this.addList)
      if (res.resultCode === 200) {
        this.$message.success('成功添加' + `${this.addList.length}` + '条线索')
        this.search()
      } else {
        this.$message.error('添加失败！')
      }
    },
    //table表格的添加为线索按钮
    async addClue(row) {
      this.addForm[0].clueMessenger = row.updateName
      this.addForm[0].enterpriseAbbreviation = row.enterpriseName
      this.addForm[0].enterpriseName = row.enterpriseName
      this.addForm[0].investmentEventId = row.id
      const { data: res } = await saveClue(this.addForm)
      if (res.resultCode === 200) {
        this.$message.success('添加成功！')
        this.addForm = { ...addFormObj }
        this.search()
      } else {
        this.$message.error('添加失败！')
      }
      /* this.$router.push({
        path: '/dataManagement/addClue',
        query: {
          enterpriseType: 0,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      }) */
    },
    //点击进入编辑事件页面
    editInformation(row) {
      this.$router.push({
        name: 'editInfomation',
        query: {
          id: row.id
        }
      })
    },
    //监听pagesize变化
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize
      this.search()
    },
    //监听页码变化
    handleCurrentChange(newCurrent) {
      this.queryInfo.baseParam.pageNum = newCurrent
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 82vh;
  overflow: scroll;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}
/deep/ .el-image__inner {
  border-radius: 5px;
}
/deep/ .el-input__inner {
  border-color: #17757a;
}
.el-table {
  /deep/tbody tr:hover > td {
    // background-color: #90c0f1;
    background-color: rgba(23, 117, 122, 0.1);
  }
}
.clue_list_input_add {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  /deep/ .input-with-select {
    width: 320px;
    margin-right: 50px;
  }
  .input_new {
    /deep/ .el-button {
      border-radius: 0 4px 4px 0;
      height: 40px;
    }
    /deep/ .el-button--default {
      background-color: #17757a;

      i {
        color: #fff;
      }
    }
  }
  .add_clue {
    background-color: #17757a;
    border-color: #17757a;
  }
}
.table_card {
  margin-top: 12px !important;
  /* overflow: scroll; */
}
.clue_table {
  margin-top: 20px;
  width: 100%;
  .no_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #ffb847;
    background-color: rgba(255, 184, 71, 0.2);
    border: 1px solid #ffb847;
  }
  .in_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #17757a;
    background-color: rgba(23, 117, 122, 0.2);
    border: 1px solid #17757a;
  }
  .to_be_renewed {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #4d70fa;
    background-color: rgba(77, 112, 250, 0.2);
    border: 1px solid #4d70fa;
  }
  .el_image {
    width: 48px;
    height: 48px;
    border-radius: 4px;
  }
  .operation_bottom {
    display: flex;
    flex-flow: row nowrap;
    font-size: 14px;
    color: #17757a;
  }
}

/* .CascaderArea {
  /deep/ .el-input__inner {
    border: 1px solid #17757a;
    color: #17757a;
    height: 34px;
    line-height: 34px;
  }
} */
/deep/ .el-form-item {
  margin-bottom: 5px;
}
.click_span {
  cursor: pointer;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
